import script from "./NewPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./NewPasswordForm.vue?vue&type=style&index=0&id=5a745fe8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a745fe8"]])

export default __exports__